import { render, staticRenderFns } from "./FileTablePage.vue?vue&type=template&id=fd564932"
import script from "./FileTablePage.vue?vue&type=script&lang=js"
export * from "./FileTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports